// `labelKey` / `pluralKey` instead of literal labels — resolved at render, and
// `formatGranularity` takes the caller's `t` (see src/i18n/README.md).
export const GRANULARITY_TYPES = [
    { id: 'hour', labelKey: 'insights.granularity.hour.label', pluralKey: 'insights.granularity.hour.plural' },
    { id: 'day', labelKey: 'insights.granularity.day.label', pluralKey: 'insights.granularity.day.plural' },
    { id: 'week', labelKey: 'insights.granularity.week.label', pluralKey: 'insights.granularity.week.plural' },
    { id: 'month', labelKey: 'insights.granularity.month.label', pluralKey: 'insights.granularity.month.plural' },
    { id: 'year', labelKey: 'insights.granularity.year.label', pluralKey: 'insights.granularity.year.plural' },
];

export const GRANULARITY_TYPE_MAP = GRANULARITY_TYPES.reduce((acc, g) => {
    acc[g.id] = g;
    return acc;
}, {});

export function formatGranularity(t, { type, amount }) {
    const g = GRANULARITY_TYPE_MAP[type];
    if (!g) return '—';
    const n = Number(amount) || 1;
    return `${n} ${t(n > 1 ? g.pluralKey : g.labelKey).toLowerCase()}`;
}
